import i18next from 'i18next';
import { currencyConstants, productConstants } from '@utils/constants';
import currencySimpleUtility from '@utils/currencySimple';
import mutationTypes from '@helpers/storeFactories/helpers/mutationTypes';
import numberFormat from '@/utils/numberFormat';
import { numberConstants } from '@/utils/constants';

const STORE_NAME = 'product';

const productCategoryById = (id) => {
    return productConstants.EVENT.CATEGORY.LIST.find((item) => item.ID === id) || null;
};

const productTypeById = (id) => {
    return productConstants.TYPES.find((item) => item.id === id) || null;
};

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        categories: null,
        transactionsSplit: null,
        types: null,
    },
    mutations: {
        [mutationTypes.SET_DATA](state, data) {
            const productCategories = data.productCategories || { items: [] };
            const productTypes = data.productTypes || { items: [] };
            const transactionsSplit = data.productTransactionsSplit || { items: [] };

            state.categories = productCategories;
            state.types = productTypes;
            state.transactionsSplit = transactionsSplit;
        },
        [mutationTypes.CLEAR_DATA](state) {
            state.categories = null;
            state.transactionsSplit = null;
            state.types = null;
        },
    },
    getters: {
        categoriesTransactions:
            (state) =>
            (returnType = Array) => {
                const noData =
                    state.categories &&
                    state.categories.items.filter((item) => item.transactions !== 0).length === 0;

                if (!state.categories || noData) {
                    return null;
                }

                let returnTypeObject = [],
                    returnTypeArray = [];

                state.categories.items.forEach((item) => {
                    const found = productCategoryById(item.categoryId);
                    found && returnTypeArray.push([i18next.t(found.i18nKey), item.transactions]);
                    found &&
                        returnTypeObject.push({
                            name: i18next.t(found.i18nKey),
                            value: numberFormat(item.transactions, numberConstants.FORMAT.INTEGER),
                            percentage: `${item.transactionsPercentage}%`,
                        });
                });

                switch (returnType) {
                    case Object:
                        return returnTypeObject;
                    default:
                        return returnTypeArray;
                }
            },
        categoriesRevenue:
            (state) =>
            (returnType = Array) => {
                const noData =
                    state.categories &&
                    state.categories.items.filter((item) => item.transactions !== 0).length === 0;

                if (!state.categories || noData) {
                    return null;
                }

                let returnTypeObject = [],
                    returnTypeArray = [];

                state.categories.items.forEach((item) => {
                    const found = productCategoryById(item.categoryId);
                    let revenue = currencySimpleUtility(item.revenue, currencyConstants.DEFAULT);
                    found && returnTypeArray.push([i18next.t(found.i18nKey), item.revenue]);
                    found &&
                        returnTypeObject.push({
                            name: i18next.t(found.i18nKey),
                            value: revenue,
                            percentage: `${item.revenuePercentage}%`,
                        });
                });

                switch (returnType) {
                    case Object:
                        return returnTypeObject;
                    default:
                        return returnTypeArray;
                }
            },
        transactionsSplitRevenue:
            (state) =>
            (returnType = Array) => {
                if (!state.transactionsSplit) return null;

                let percentCount = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                state.transactionsSplit.items.forEach((item) => {
                    percentCount += item.revenuePercentage;
                    returnTypeArray.push([
                        item.ticketType,
                        item.revenuePercentage,
                        `${item.ticketType}\n ${currencySimpleUtility(item.revenue, currencyConstants.DEFAULT)} (${item.revenuePercentage}%)`,
                    ]);
                    returnTypeObject.push({
                        type: item.ticketType,
                        value: currencySimpleUtility(item.revenue, currencyConstants.DEFAULT),
                        percentage: `${item.revenuePercentage}%`,
                    });
                });

                if (!percentCount) return null;

                switch (returnType) {
                    case Object:
                        return returnTypeObject;
                    default:
                        return returnTypeArray;
                }
            },
        transactionsSplitTransactions:
            (state) =>
            (returnType = Array) => {
                if (!state.transactionsSplit) return null;

                let percentCount = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                state.transactionsSplit.items.forEach((item) => {
                    percentCount += item.transactionsPercentage;
                    returnTypeArray.push([
                        item.ticketType,
                        item.transactionsPercentage,
                        `${item.ticketType}\n ${numberFormat(item.transactions, numberConstants.FORMAT.INTEGER)} (${item.transactionsPercentage}%)`,
                    ]);
                    returnTypeObject.push({
                        type: item.ticketType,
                        value: numberFormat(item.transactions, numberConstants.FORMAT.INTEGER),
                        percentage: `${item.revenuePercentage}%`,
                    });
                });

                if (!percentCount) return null;

                switch (returnType) {
                    case Object:
                        return returnTypeObject;
                    default:
                        return returnTypeArray;
                }
            },
        typesTransactions:
            (state) =>
            (returnType = Array) => {
                if (!state.types || state.types.totalCount === 0) {
                    return null;
                }

                let returnTypeObject = [],
                    returnTypeArray = [];

                state.types.items.forEach((item) => {
                    const found = productTypeById(item.typeId);
                    found && returnTypeArray.push([found.name, item.transactions]);
                    found &&
                        returnTypeObject.push({
                            name: found.name,
                            value: numberFormat(item.transactions, numberConstants.FORMAT.INTEGER),
                            percentage: `${item.transactionsPercentage}%`,
                        });
                });

                switch (returnType) {
                    case Object:
                        return returnTypeObject;
                    default:
                        return returnTypeArray;
                }
            },
        typesRevenue:
            (state) =>
            (returnType = Array) => {
                if (!state.types || state.types.totalCount === 0) {
                    return null;
                }

                let returnTypeObject = [],
                    returnTypeArray = [];

                state.types.items.forEach((item) => {
                    const found = productTypeById(item.typeId);
                    let revenue = currencySimpleUtility(item.revenue, currencyConstants.DEFAULT);

                    found && returnTypeArray.push([found.name, item.revenue]);
                    found &&
                        returnTypeObject.push({
                            name: found.name,
                            value: revenue,
                            percentage: `${item.revenuePercentage}%`,
                        });
                });

                switch (returnType) {
                    case Object:
                        return returnTypeObject;
                    default:
                        return returnTypeArray;
                }
            },
    },
};
